import { Text } from '@cmpsr/components';

type NavigationBarSelectedItemProps = {
  label: string;
  variant?: 'dark' | 'light';
};

export default function NavigationBarSelectedItem({ label, variant = 'dark' }: NavigationBarSelectedItemProps) {
  const isLight = variant === 'light';
  const color = isLight ? 'text-link-primary-default' : 'text-link-light-default';
  const shadowColor = isLight ? 'var(--chakra-colors-text-link-primary-default)' : 'var(--chakra-colors-text-link-light-default)';

  return (
    <Text
      variant="text-body-medium"
      color={color}
      boxShadow={`inset 0px -4px 0px 0px ${shadowColor}`}
      px={4}
      py={7}
    >
      {label}
    </Text>
  );
}
